module.exports = __webpack_public_path__ + "static/media/paypal-logomark.68189cef.svg";